import { faAddressBook, faBriefcase, faBuildingColumns, faCalendarCheck, faClock, faEnvelope, faFlag, faLandmarkDome, faLocationCrosshairs, faLocationDot, faMapLocationDot, faPenFancy, faPersonWalkingArrowRight, faPhone, faUser, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { FaFacebook, FaInstagramSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa'
import { formatDate, getCountryCode, getValueOrPlaceHolder, maskContactNumber } from '../../../../Utils/helpers/commonhelper'

export const ContactInfo = ({ contactDetails, checkTwilio, parsedUserEmail, parsedUserPhone, parsedTimezone, customer }) => {
    const [showAllEmails, setShowAllEmails] = useState(false);
    const [showAllPhoneNumbers, setShowAllPhoneNumbers] = useState(false);
    const parsedData = parsedUserPhone !== null && JSON.parse(parsedUserPhone)
    const customFields = Array.isArray(contactDetails?.custom_fields)
        ? contactDetails.custom_fields.map((customField) => ({
            ...customField,
            parsedValue: parseCustomFieldValue(customField.value),
        }))
        : [];
    return (
        <Row className="w-100 ms-0 ps-0 pe-2 mb-2 contactDetailOffcanvas">
            <Col
                md={12}
                className="tab-container bg-white ps-0 pe-0"
                style={styles.tabContainer}
            >
                <Tab.Container defaultActiveKey="products">
                    <Nav
                        variant="pills"
                        className="nav-style-1 mb-0 d-flex flex-nowrap "
                    >
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="products"
                                style={styles.navLinksStyle}
                            >
                                Communication
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="cart"
                                style={styles.navLinksStyle}
                            >
                                Location
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="orders"
                                style={styles.navLinksStyle}
                            >
                                Social
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="offers"
                                style={styles.navLinksStyle}
                            >
                                Professional
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "22%" }}
                        >
                            <Nav.Link
                                eventKey="Campaign"
                                style={styles.navLinksStyleLast}
                            >
                                Internal
                            </Nav.Link>
                        </Nav.Item>
                        {customFields.length > 0 && (
                            <Nav.Item
                                className="me-0"
                                style={{ minWidth: "22%" }}
                            >
                                <Nav.Link
                                    eventKey="additionalInformation"
                                    style={styles.navLinksStyleLast}
                                >
                                    Additional Inormation
                                </Nav.Link>
                            </Nav.Item>
                        )}
                        <Nav.Item
                            eventKey="Campaign"
                            className="me-0"
                            style={{
                                width: "-webkit-fill-available",
                            }}
                        >
                            {" "}
                            <Nav.Link
                                eventKey="Campaign"
                                style={styles.navLinksStyleLastLast}
                            ></Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane
                            eventKey="products"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-0 mt-3">
                                <Col
                                    md={6}
                                    className="mb-2 d-flex align-items-start "
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "1px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Emails
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >
                                            {parsedUserEmail?.[0] ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "290px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                        }}
                                                        title={parsedUserEmail[0].email} // tooltip on hover
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display: "inline-block",
                                                                width: "70px",
                                                                minWidth: "60px",
                                                                textTransform: 'capitalize'
                                                            }}
                                                        >
                                                            {parsedUserEmail[0].email_type}
                                                        </span>
                                                        : {parsedUserEmail[0].email}
                                                    </span>
                                                    <br />
                                                    {parsedUserEmail.length > 1 &&
                                                        !showAllEmails && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    // marginLeft: "8px",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setShowAllEmails(true)
                                                                }}
                                                            >
                                                                +{parsedUserEmail.length - 1}{" "}
                                                                more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                "No Data"
                                            )}
                                        </div>

                                        {/* Expanded emails */}
                                        {showAllEmails && (
                                            <div
                                                style={{
                                                    marginTop: "6px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {parsedUserEmail
                                                    .slice(1)
                                                    .map((allEmails, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                marginBottom: "4px",
                                                                display: "inline-block",
                                                                maxWidth: "250px", // adjust as needed
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                verticalAlign: "middle",
                                                                // border:"1px solid black"
                                                            }}
                                                            title={allEmails.email} // tooltip
                                                        >
                                                            <span
                                                                className=" d-inline-block"
                                                                style={{
                                                                    // display:"inline-block !important",
                                                                    width: "70px",
                                                                    minWidth: "50px"
                                                                }}
                                                            >
                                                                {allEmails.email_type}
                                                                {/* {allEmails?.email_type ===
                                                "Office"
                                                  ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                                  : " "} */}
                                                            </span>
                                                            : {allEmails.email}
                                                        </div>
                                                    ))}
                                                <br />
                                                <span
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setShowAllEmails(false)
                                                    }
                                                    }
                                                >
                                                    Show less
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col
                                    md={6}
                                    className="mb-4 d-flex align-items-start"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "2px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Contacts
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >
                                            {parsedData?.[0] ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "280px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                            letterSpacing: "0.25px"
                                                        }}
                                                        onClick={() => parsedData !== null && checkTwilio()}
                                                        title={`${parsedData[0].phone_type} ${getCountryCode(parsedData)} ${maskContactNumber(customer, parsedData[0].phone)}`} // full tooltip
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display:"inline-block !important",
                                                                width: "60px",
                                                                minWidth: "50px",
                                                                letterSpacing: '0.25px',
                                                                textTransform: "capitalize"
                                                            }}
                                                        >
                                                            {parsedData[0].phone_type}
                                                        </span>
                                                        : +{parsedData[0].country_code}{" "}
                                                        {maskContactNumber(customer, parsedData[0].phone)}
                                                    </span>

                                                    <br />
                                                    {parsedData.length > 1 &&
                                                        !showAllPhoneNumbers && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={() =>
                                                                    setShowAllPhoneNumbers(true)
                                                                }
                                                            >
                                                                +{parsedData.length - 1}{" "}
                                                                more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>

                                        {/* Expanded contacts */}
                                        {showAllPhoneNumbers && (
                                            <>
                                                <div
                                                    style={{
                                                        marginTop: "6px",
                                                        fontSize: "14px",
                                                        color: "#333",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    className='d-flex'
                                                >
                                                    <div style={{ maxWidth: "2rem" }}>
                                                        {parsedData
                                                            .slice(1)
                                                            .map((allPhones, index) => (
                                                                <div
                                                                    key={index}
                                                                    style={{
                                                                        marginBottom: "4px",
                                                                        display: "inline-block",
                                                                        maxWidth: "250px",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        verticalAlign: "middle",
                                                                        letterSpacing: '0.25px',
                                                                    }}
                                                                    title={`${allPhones.phone_type} +${allPhones.country_code} ${allPhones.phone}`} // tooltip
                                                                    onClick={() => checkTwilio()}
                                                                >
                                                                    <span
                                                                        className=" d-inline-block"
                                                                        style={{
                                                                            // display:"inline-block !important",
                                                                            width: "60px",
                                                                            minWidth: "50px",
                                                                        }}
                                                                    >
                                                                        {allPhones?.phone_type}
                                                                    </span>
                                                                    : +{allPhones.country_code}{" "}
                                                                    {maskContactNumber(customer, allPhones.phone)}
                                                                </div>
                                                            ))}
                                                        <span
                                                            style={{
                                                                color: "#0d6efd",
                                                                cursor: "pointer",
                                                                fontSize: "13px",
                                                                textWrap: 'nowrap'
                                                            }}
                                                            onClick={() =>
                                                                setShowAllPhoneNumbers(false)
                                                            }
                                                        >
                                                            Show less
                                                        </span>
                                                    </div>
                                                    {/* <br />
                                                    
                                                    <span>some test</span> */}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-0 mt-0">
                                <Col
                                    md={6}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "2px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            TimeZone
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(parsedTimezone.label)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="cart"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faFlag}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Country
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.country_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBuildingColumns}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            State
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.state_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationCrosshairs}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            City
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.city_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Address
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.address)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faMapLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Zip Code
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.zipcode)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="orders"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaFacebook
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Facebook
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.facebook || "-"}
                                            {getValueOrPlaceHolder(contactDetails?.facebook)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaLinkedin
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Linkedin
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.linkedin)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-4 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaInstagramSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Instagram
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.instagram)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaTwitterSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Twitter
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.twitter)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="offers"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLandmarkDome}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Company
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.company_name, "Unmapped Company")}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBriefcase}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Department{" "}
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.department)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-3 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faAddressBook}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Designation{" "}
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.designation)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPenFancy}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Decision Maker
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.decision_maker}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="Campaign"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created By
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.added_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {formatDate(contactDetails?.created_at) ||
                                                "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified By
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.updated_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faCalendarCheck}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(formatDate(contactDetails?.updated_at))}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faUserCircle}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Lead Owner
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.owner_name, "No Owner")}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-4 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPersonWalkingArrowRight}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Lead Source
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(contactDetails?.lead_source_name, "No Source")}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        {customFields.length > 0 && (
                            <Tab.Pane
                                eventKey="additionalInformation"
                                style={{
                                    border: "none",
                                    animation: "cardEntry 1s ease-out forwards",
                                }}
                            >
                                <Row className="w-100 ms-0 mb-4 mt-3">
                                    {customFields.map((customField, index) => (
                                        <Col
                                            md={4}
                                            className="mb-3 d-flex align-items-start"
                                            key={`${customField.module_name}-${index}`}
                                        >
                                            <FontAwesomeIcon
                                                icon={faAddressBook}
                                                className="fs-16"
                                                style={{
                                                    fontSize: "16px",
                                                    marginRight: "13px",
                                                    color: "#2656a8",
                                                    marginTop: "4px",
                                                }}
                                            />
                                            <div>
                                                <p className="mb-0" style={{ ...styles.labels, textTransform: 'capitalize' }}>
                                                    {customField.module_name || "Custom Field"}
                                                </p>
                                                <p className="mb-0" style={styles.values}>
                                                    {formatCustomFieldValue(customField.parsedValue)}
                                                </p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Tab.Pane>
                        )}
                    </Tab.Content>
                </Tab.Container>
            </Col>
        </Row>
    )
}

const parseCustomFieldValue = (value) => {
    if (typeof value !== "string") return value;

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

const formatCustomFieldValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
};

const styles = {
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    navLinksStyleLast: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "none",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    navLinksStyleLastLast: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "none",
        fontSize: 14,
        height: "99%",
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
    },
};